import React from 'react';

import PRODUCTS from './ProductDataTypes';
import {getSiteConfig} from '../config';

const SITE_CONFIG = getSiteConfig();

const generateResourceId = (id) => {
    return PRODUCTS.BAKRI_POSTPARTUM_BALLOON+"_"+id;
};


const data =
    {
        id: PRODUCTS.BAKRI_POSTPARTUM_BALLOON,
        alt:"Bakri Postpartum Balloon",
        title:(<React.Fragment>Bakri Postpartum Balloon</React.Fragment>),
        productImages: [
            require('../assets/images/bakri-postpartum-balloon/bakri-postpartum-balloon-product.jpg'),
            require('../assets/images/bakri-postpartum-balloon/bakri-postpartum-balloon-product@2x.jpg'),
            require('../assets/images/bakri-postpartum-balloon/bakri-postpartum-balloon-product@3x.jpg')
        ],
        description:'',
        videoData:{
            videoSets:[
                {
                    isChapterBased:true,
                    videos:[
                        {
                            resourceId:generateResourceId("vs1v1"),
                            title:null,
                            subTitle: "Bakri Procedural Animation",
                            description:null,
                            wistiaId:"43pl7xgt3y",
                            wistiaConfig:{
                                padding:"56.25% 0 0 0"
                            }
                        }
                    ]

                }
            ]
        },
        documentData:{
            documents:[
                {
                    resourceId: generateResourceId("d1"),
                    title:"Bakri Instructions for Use",
                    description: null,
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/bakri-postpartum-balloon/Bakri Instructions for Use.pdf",
                    thumbnails:[
                        require("../assets/images/bakri-postpartum-balloon/doc-thumbs/bakri-instructions-for-use.jpg"),
                        require("../assets/images/bakri-postpartum-balloon/doc-thumbs/bakri-instructions-for-use@2x.jpg"),
                        require("../assets/images/bakri-postpartum-balloon/doc-thumbs/bakri-instructions-for-use@3x.jpg")
                    ]
                },

                {
                    resourceId: generateResourceId("d2"),
                    title:"Bakri Steps of Use Poster",
                    description: null,
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/bakri-postpartum-balloon/Bakri Steps of Use Poster.pdf",
                    thumbnails:[
                        require("../assets/images/bakri-postpartum-balloon/doc-thumbs/bakri-steps-of-use-poster.jpg"),
                        require("../assets/images/bakri-postpartum-balloon/doc-thumbs/bakri-steps-of-use-poster@2x.jpg"),
                        require("../assets/images/bakri-postpartum-balloon/doc-thumbs/bakri-steps-of-use-poster@3x.jpg")
                    ]
                }
            ]
        },
        externalProductId:""
    };


export default data;








